import { copyToClipboard } from '@databases/copy-paste/copy-helper';
import { getBaseUrl, useDatabaseContent } from '@databases/database-state';
import { type DatabaseView, ViewId } from '@databases/types/database/view';
import { getDatabasePath } from '@databases/utils/urls';
import { useCallback } from 'react';

const useCopyViewLink = (contentId: string) => {
  const { unsavedViewId, spaceKey } = useDatabaseContent();
  const databasePath = getDatabasePath({
    spaceKey: spaceKey,
    contentId,
  });
  const baseUrl = getBaseUrl();

  return useCallback(
    (view: DatabaseView) => {
      const url = new URL(baseUrl + databasePath);

      url.searchParams.set('savedViewId', view.id);

      if (view.id === ViewId.UNSAVED && unsavedViewId) {
        url.searchParams.set('unsavedView', unsavedViewId);
      } else {
        url.searchParams.delete('unsavedView');
      }

      return copyToClipboard(url.toString(), 'text/plain');
    },
    [baseUrl, databasePath, unsavedViewId]
  );
};

export default useCopyViewLink;
